import React from 'react'

import EditDistributorForm from '../../modules/Distributor/components/EditDistributorForm'
export default function EditDistributorPage() {
  return <EditDistributorForm />
}
